import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section, ReviewFlag } from "@/components/LegalLayout";
import { useSiteSettings } from "@/lib/useSiteSettings";

export default function Legal() {
  const s = useSiteSettings();
  return (
    <LegalLayout metaTitle="Legal & Disclaimer — Nearfluence" metaDescription="Important information about how Nearfluence works as a platform connecting independent businesses and creators." title="Legal & Disclaimer Information" subtitle="How Nearfluence works as a platform — in plain terms.">
      <Section title="Nearfluence is a platform">
        <p>Nearfluence is a platform that connects independent businesses and creators. It provides technology to help them discover each other, communicate and arrange collaborations.</p>
      </Section>
      <Section title="What we do not guarantee">
        <p>Unless we explicitly state otherwise:</p>
        <ul className="mt-2 list-disc space-y-1.5 pl-5">
          <li>Nearfluence does not guarantee that a creator will receive opportunities.</li>
          <li>Nearfluence does not guarantee that an opportunity will receive applications.</li>
          <li>Nearfluence does not guarantee follower, engagement, audience or other user-provided statistics.</li>
          <li>Nearfluence does not guarantee campaign performance, reach, sales or other commercial outcomes.</li>
        </ul>
      </Section>
      <Section title="Your responsibilities">
        <p>Users should independently assess whether another user or opportunity is appropriate for them. We do not carry out background checks or identity verification of users unless explicitly stated.</p>
        <p>Agreements between businesses and creators may create legal obligations between those parties. You are responsible for the terms you agree with another user.</p>
      </Section>
      <Section title="Your statutory rights">
        <p>Nothing on this page removes or limits any rights you have under law that cannot be excluded, including your statutory rights.</p>
      </Section>
      <Section title="Company information">
        <p>Operating entity: <ReviewFlag show={!s?.company_name}>{s?.company_name}</ReviewFlag>. Company number: <ReviewFlag show={!s?.company_number}>{s?.company_number}</ReviewFlag>. Registered office: <ReviewFlag show={!s?.registered_office}>{s?.registered_office}</ReviewFlag>.</p>
        <p>See also our <Link to="/terms" className="text-emerald-600 hover:underline">Terms of Use</Link> and <Link to="/privacy" className="text-emerald-600 hover:underline">Privacy Policy</Link>.</p>
      </Section>
    </LegalLayout>
  );
}
